import mock from '@/@fake-db/mock'
/* eslint-disable global-require */
const data = null
/*const data = {
  statisticsItems: [
    {
      icon: 'TrendingUpIcon',
      color: 'light-primary',
      title: '500',
      subtitle: 'total',
      customClass: 'mb-2 mb-xl-0',
    },
    {
      icon: 'UserIcon',
      color: 'light-info',
      title: '300',
      subtitle: 'Shortlisted',
      customClass: 'mb-2 mb-xl-0',
    },
    {
      icon: 'BoxIcon',
      color: 'light-danger',
      title: '100',
      subtitle: 'Rejected',
      customClass: 'mb-2 mb-sm-0',
    },
    {
      icon: 'DollarSignIcon',
      color: 'light-success',
      title: '100',
      subtitle: 'Joined',
      customClass: '',
    },
  ],
  revenueItems: [
    {
      icon: 'TrendingUpIcon',
      color: 'light-primary',
      title: '30',
      subtitle: 'Active clients',
      customClass: 'mb-2 mb-sm-0',
    },
    {
      icon: 'UserIcon',
      color: 'light-info',
      title: '100',
      subtitle: 'Active Positions',
      customClass: '',
    },
  ],
  clientClosureItems: [
    {
      name: 'Evalueserve',
      shortlisted: 5,
      joined: 71,
      pending: 4,
    },
    {
      name: 'Genpact',
      shortlisted: 5,
      joined: 198,
      pending: 5,
    },
    {
      name: 'GVR',
      shortlisted: 5,
      joined: 7,
      pending: 0,
    },
    {
      name: 'KPMG',
      shortlisted: 5,
      joined: 55,
      pending: 1,
    },
    {
      name: 'WNS',
      shortlisted: 5,
      joined: 2,
      pending: 0,
    },
    {
      name: 'Paytm',
      shortlisted: 5,
      joined: 5,
      pending: 0,
    },
    {
      name: 'Goldman Sachs',
      shortlisted: 5,
      joined: 4,
      pending: 1,
    },
    {
      name: 'Infosys',
      shortlisted: 5,
      joined: 5,
      pending: 1,
    },
    {
      name: 'Tech Mahindra',
      shortlisted: 5,
      joined: 6,
      pending: 1,
    },
    {
      name: 'Markets & Markets',
      shortlisted: 5,
      joined: 2,
      pending: 0,
    },
    {
      name: 'Amazon',
      shortlisted: 5,
      joined: 4,
      pending: 0,
    },
    {
      name: 'Affinity',
      shortlisted: 5,
      joined: 4,
      pending: 2,
    },
    {
      name: 'Accenture',
      shortlisted: 5,
      joined: 2,
      pending: 1,
    },
  ],
  teamClosureItems: [
    {
      recruiter: 'Aakanksha',
      shortlisted: 5,
      joined: 19,
      pending: 0,
    },
    {
      recruiter: 'Almas',
      shortlisted: 5,
      joined: 18,
      pending: 1,
    },
    {
      recruiter: 'Dhiraj',
      shortlisted: 5,
      joined: 1,
      pending: 0,
    },
    {
      recruiter: 'Farheen',
      shortlisted: 5,
      joined: 9,
      pending: 0,
    },
    {
      recruiter: 'Fazal',
      shortlisted: 5,
      joined: 11,
      pending: 2,
    },
    {
      recruiter: 'Gausia',
      shortlisted: 5,
      joined: 13,
      pending: 1,
    },
    {
      recruiter: 'Jhimi',
      shortlisted: 5,
      joined: 7,
      pending: 1,
    },
    {
      recruiter: 'Khushi',
      shortlisted: 5,
      joined: 13,
      pending: 1,
    },
    {
      recruiter: 'Madhanaaz',
      shortlisted: 5,
      joined: 17,
      pending: 0,
    },
    {
      recruiter: 'Monika',
      shortlisted: 5,
      joined: 9,
      pending: 1,
    },
    {
      recruiter: 'Nazneen',
      shortlisted: 5,
      joined: 11,
      pending: 1,
    },
    {
      recruiter: 'Neha',
      shortlisted: 5,
      joined: 21,
      pending: 0,
    },
    {
      recruiter: 'Nidhi',
      shortlisted: 5,
      joined: 10,
      pending: 2,
    },
    {
      recruiter: 'Nikhil',
      shortlisted: 5,
      joined: 1,
      pending: 0,
    },
    {
      recruiter: 'Nikita',
      shortlisted: 5,
      joined: 14,
      pending: 1,
    },
    {
      recruiter: 'Nisha',
      shortlisted: 5,
      joined: 3,
      pending: 0,
    },
    {
      recruiter: 'Prashant',
      shortlisted: 5,
      joined: 1,
      pending: 0,
    },
    {
      recruiter: 'Rajas',
      shortlisted: 5,
      joined: 3,
      pending: 0,
    },
    {
      recruiter: 'Renuka',
      shortlisted: 5,
      joined: 13,
      pending: 2,
    },
    {
      recruiter: 'Rishabh',
      shortlisted: 5,
      joined: 19,
      pending: 1,
    },
    {
      recruiter: 'Sattva',
      shortlisted: 5,
      joined: 14,
      pending: 0,
    },
    {
      recruiter: 'Sheeba',
      shortlisted: 5,
      joined: 8,
      pending: 0,
    },
    {
      recruiter: 'Shruti',
      shortlisted: 5,
      joined: 6,
      pending: 0,
    },
    {
      recruiter: 'Steffi',
      shortlisted: 5,
      joined: 18,
      pending: 0,
    },
    {
      recruiter: 'Tanzeem',
      shortlisted: 5,
      joined: 9,
      pending: 2,
    },
    {
      recruiter: 'Viral',
      shortlisted: 5,
      joined: 8,
      pending: 0,
    },
  ],
}*/
/* eslint-disable global-require */
mock.onGet('/admin/data').reply(() => [200, data])
